import { render } from "./SidenavDivider.vue?vue&type=template&id=11a6acd2"
import script from "./SidenavDivider.vue?vue&type=script&lang=js"
export * from "./SidenavDivider.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__